var map = {
	"./Screenshot 2024-05-12 230610.pngZone.Identifier": 487,
	"./advvr-thumb.png": 427,
	"./ar-thumb.png": 325,
	"./ar-thumb.pngZone.Identifier": 477,
	"./contactManager.jpg": 62,
	"./diceGame.jpg": 268,
	"./grayWebsite.jpg": 943,
	"./heart.jpg": 839,
	"./mr-thumb.png": 937,
	"./place-cont-async.pngZone.Identifier": 502,
	"./placeholder.png": 564,
	"./placeholder.pngZone.Identifier": 630,
	"./pythonMenu.jpg": 880,
	"./rain-project.png": 725,
	"./scheduler.jpg": 88,
	"./senserator-thumb.jpg": 704,
	"./thesis-thumb.png": 460,
	"./vr-thumb.png": 148,
	"./vr-thumb.pngZone.Identifier": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;